import r, { css as t } from "styled-components";
import { Column as n } from "./atoms-v212.js";
import { Grid as p } from "./atoms-v216.js";
import { Specs as d } from "./atoms-v239.js";
import { Base as l } from "./atoms-v2777.js";
import { breakpoints as a } from "./atoms-v2125.js";
const k = r(p)`
  ${l}
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.productive")) == null ? void 0 : o.toJS();
}}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.secondary")};
  padding-block: 16px;

  @media ${a.medium} {
    padding-block: 40px;
  }

  @media ${a.large} {
    padding-block: 0;
  }

  ${({ $variant: i }) => {
  switch (i) {
    case "v3":
      return t`
          @media ${a.small} {
            row-gap: 24px;
          }
        `;
    case "v2":
      return t`
          row-gap: 24px;
        `;
    case "v1":
      return t`
          row-gap: 16px;

          @media ${a.large} {
            row-gap: 0;
          }
        `;
    default:
      return "";
  }
}}

  @media ${a.large} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : o.toJS();
}}
  }
`, f = r(n)`
  background-color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.surface.light.layer01")};
  border-radius: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.mainRadius")}px;
`, b = r(n)`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  row-gap: 24px;

  @media ${a.medium} {
    padding-block: 24px;
    padding-inline: 46px;
    text-align: center;
  }

  @media ${a.large} {
    padding-inline: 0;
  }
`, S = r(n)`
  display: flex;
  flex-direction: column;

  ${({ $variant: i, theme: o }) => {
  var s;
  switch (i) {
    case "v3":
      return t`
          ${(s = o == null ? void 0 : o.get("tokens.heading.06")) == null ? void 0 : s.toJS()}

          row-gap: 8px;

          @media ${a.small} {
            order: 2;
          }

          @media ${a.xLarge} {
            padding-right: 60px;
          }
        `;
    case "v2":
      return t`
          align-items: center;
          row-gap: 16px;
        `;
    default:
      return t`
          row-gap: 12px;
        `;
  }
}}

  @media ${a.large} {
    row-gap: ${({ $variant: i }) => i === "v3" ? 8 : 24}px;
  }
`, e = r(d)`
  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};

  ${({ $variant: i }) => {
  switch (i) {
    case "v3":
      return t`
          margin-top: 16px;
        `;
  }
}}
`, w = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : o.toJS();
}}

  flex-grow: 1;

  @media ${a.large} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.05")) == null ? void 0 : o.toJS();
}}
  }

  @media ${a.max} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.06")) == null ? void 0 : o.toJS();
}}
  }
`, y = r.h5`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.02")) == null ? void 0 : o.toJS();
}}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};
  margin: 0;

  @media ${a.medium} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.03")) == null ? void 0 : o.toJS();
}}
  }

  @media ${a.xLarge} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.04")) == null ? void 0 : o.toJS();
}}
  }
`, B = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.helper.expressive")) == null ? void 0 : o.toJS();
}}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};
  text-transform: uppercase;
`, J = r(n)`
  align-self: start;
  order: 1;

  @media ${a.medium} {
    order: 2;
  }

  ${({ $hasMultiplePictures: i }) => i ? t`
          --overX: clamp(0px, calc(var(--S) - var(--B) / 2), 1000px);
          --overY: clamp(0px, calc(var(--S) - var(--B) / 2), 1000px);

          /* This makes the container as big as the union of both photos,
             so it *reserves space* and doesn't sit on top of other elements. */
          height: calc(var(--B) + var(--overY));
          isolation: isolate;
          max-width: 100%;
          position: relative;

          /* This makes the container as big as the union of both photos,
             so it *reserves space* and doesn't sit on top of other elements. */
          width: calc(var(--B) + var(--overX));

          & picture {
            display: block;
          }

          /* Big photo */
          & picture:nth-child(1) {
            height: var(--B);
            left: var(--overX);
            position: absolute;
            top: 0;
            width: var(--B);
            z-index: 1;
          }

          & picture:nth-child(1) img {
            display: block;
            height: 100%;
            object-fit: cover;
            width: 100%;
          }

          /* Small photo */
          & picture:nth-child(2) {
            height: var(--S);
            left: calc(var(--overX) + var(--B) / 2 - var(--S));
            position: absolute;
            top: calc(var(--B) / 2);
            width: var(--S);
            z-index: 2;
          }

          & picture:nth-child(2) img {
            display: block;
            height: 100%;
            object-fit: cover;
            width: 100%;
          }

          @media ${a.large} {
            --B: 377px;
            --S: 279px;
          }

          @media ${a.xLarge} {
            --B: 361px;
            --S: 268px;
          }
        ` : t`
          /* Single-photo case */
          align-self: center;

          & picture {
            align-self: end;
            display: block;
            width: auto;
          }

          & picture img {
            display: block;
            height: 100%;
            width: 100%;
          }
        `}
`, C = r(e)`
  display: grid;
  grid-template-columns: repeat(2, auto);
`, m = r.div`
  align-self: flex-start;

  @media ${a.large} {
    padding-bottom: 16px;
  }
`, L = r.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media ${a.medium} {
    row-gap: 8px;
  }
`, T = r(n)`
  border-top: 1px solid ${({ theme: i }) => i == null ? void 0 : i.get("tokens.border.light.light")};
  display: none;
  padding-top: 24px;

  @media ${a.large} {
    display: block;
  }
`;
export {
  S as Content,
  k as Description,
  w as ExpressiveContent,
  C as GridSpecs,
  J as Pictures,
  m as SpecsContainer,
  e as SpecsList,
  B as Subhead,
  y as Title,
  T as TopBar,
  f as Vertical,
  b as VerticalContainer,
  L as VerticalInnerContainer
};
